import React, { Component } from 'react';
import CKPButton from '../../forms/Button';
import IconButton from '@material-ui/core/IconButton';
import AttachIcon from '@material-ui/icons/AttachFile';
import DeleteIcon from '@material-ui/icons/Delete';

class UploadButton extends Component {
    state = { fileName: '', error: '' };
    componentDidUpdate(prevProps) {
        if (prevProps.value && !this.props.value) {
            this.setState({ fileName: '', fileData: '' });
        }
    }
    _onFileSelect = event => {
        if (event.target.files[0]) {
            const size = (event.target.files[0].size / 1024 / 1024).toFixed(4);
            if (this.props.maxSize && size > this.props.maxSize) {
                this.setState({ error: `Max. size is ${this.props.maxSize} MBs.`, fileName: '' });
                this.props.onChange('', this.props.name);
            } else {
                this.setState({ error: '', fileName: (event.target.files[0] && event.target.files[0].name) || '' });
                this.props.onChange && this.props.onChange(event.target.files[0], this.props.name);
                event.target.value = null;
            }
        }
    };
    render() {
        return (
            <div className={`ckp-upload-button ${this.props.className}`}>
                {this.props.readOnly ? (
                    <React.Fragment>
                        <a
                            onClick={this.props.onClick}
                            download={this.props.fileName || this.state.fileName}
                            className="ckp-upload-button-file"
                        >
                            <AttachIcon className="ckp-upload-button-file-icon" />
                            {this.props.fileName || this.state.fileName}
                        </a>
                        {!this.props.readOnly ? (
                            <IconButton onClick={this.props.onDelete} className="ckp-upload-button-file-remove">
                                <DeleteIcon />
                            </IconButton>
                        ) : null}
                    </React.Fragment>
                ) : !this.props.readOnly ? (
                    <React.Fragment>
                        <input
                            className="ckp-upload-button-input"
                            type="file"
                            name={this.props.name}
                            id={`ckp-upload-button-${this.props.name}`}
                            onChange={this._onFileSelect}
                            accept={this.props.accept || ''}
                        />
                        <CKPButton label={this.props.label} className="ckp-upload-button-button" />
                        {this.state.fileName ? (
                            <span className="ckp-upload-button-filename">Selected: {this.state.fileName}</span>
                        ) : null}
                        {this.state.error ? <span className="ckp-upload-button-error">{this.state.error}</span> : null}
                    </React.Fragment>
                ) : null}
            </div>
        );
    }
}

UploadButton.defaultProps = {
    label: 'Select File',
    className: '',
    accept: ''
};

export default UploadButton;
